import React from 'react'
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core'

import { FreightShipment } from 'src/api/models'

import { FreightOrderCompact } from './FreightOrder'

interface FreightShipmentCompactProps {
  obj: FreightShipment
}

export const FreightShipmentCompact = (props: FreightShipmentCompactProps) => {
  const { obj } = props
  if (obj.order) {
    obj.order.client = obj.client
  }
  return (
    <Paper variant="outlined">
      <Card>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              Shipment #{obj.trackingNumber || '-'} on {obj.carrier?.name || 'no carrier'}
            </Grid>
            {obj.order && (
              <>
                <Grid item>
                   For
                </Grid>
                <Grid item>
                   <FreightOrderCompact obj={obj.order} />
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Paper>
  )
}
